<section class="py-24 bg-gradient-to-b from-white via-blue-50/50 to-white overflow-hidden font-sans relative">
  <div
    class="absolute top-0 right-0 -translate-y-1/2 translate-x-1/4 w-[500px] h-[500px] bg-blue-100/50 rounded-full blur-3xl -z-10">
  </div>

  <div class="max-w-7xl mx-auto px-6">
    <div class="text-center mb-20">
      <span
        class="inline-block px-4 py-1.5 mb-4 text-sm font-bold tracking-widest text-[#3368fa] uppercase bg-blue-50 rounded-full">Efficiency
        & Growth</span>
      <h2 class="text-4xl md:text-5xl font-black text-[#002670] leading-[1.15]">
        শিক্ষকদের ক্লারিক্যাল কাজের বোঝা কমায় <br class="hidden md:block">
        ও <span
          class="text-transparent bg-clip-text bg-gradient-to-r from-[#3368fa] to-[#4247a1] relative inline-block">প্রতিষ্ঠানের
          গতি বাড়ায়
          <span class="absolute -bottom-3 left-0 w-full h-1.5 bg-orange-400/80 rounded-full blur-[1px]"></span>
        </span>
      </h2>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
      <div class="lg:col-span-5 relative group">
        <div
          class="absolute inset-0 bg-blue-400/20 rounded-full blur-3xl scale-75 group-hover:scale-100 transition-transform duration-1000">
        </div>
        <div class="relative animate-float">
          <img loading="lazy" src="431.jpg" alt="Efficiency"
            class="w-full max-w-lg mx-auto h-auto drop-shadow-[0_20px_50px_rgba(0,38,112,0.15)] rounded-3xl">
        </div>
      </div>

      <div class="lg:col-span-7 grid grid-cols-1 md:grid-cols-3 gap-6">
        @for (feature of features; track feature.title) {
        <div
          class="relative overflow-hidden flex flex-col items-center justify-center min-h-[210px] p-7 text-center rounded-[2.5rem] border border-gray-100 bg-white/90 backdrop-blur-sm shadow-[0_10px_30px_-15px_rgba(0,0,0,0.05)] transition-all duration-500 hover:shadow-[0_20px_40px_-10px_rgba(51,104,250,0.15)] hover:border-[#3368fa]/30 hover:-translate-y-2 group">

          <div
            class="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#3368fa] to-[#4247a1] opacity-0 transition-opacity duration-500 group-hover:opacity-100">
          </div>

          <div
            class="w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center text-3xl mb-5 text-[#3368fa] transition-all duration-500 group-hover:scale-110 group-hover:rotate-[8deg] group-hover:shadow-lg group-hover:from-[#3368fa] group-hover:to-[#1e2171] group-hover:text-white">
            <i [class]="feature.icon"></i>
          </div>

          <h3 class="text-[#002670] font-black text-2xl tracking-tight transition-colors duration-300">{{ feature.title
            }}</h3>
          <p class="text-gray-500 text-sm font-semibold leading-relaxed">{{ feature.description }}</p>
        </div>
        }
      </div>
    </div>
  </div>
</section>